import event from '../assets/popup.jpg'

export const newEvent = {
    name: 'Pre-Departure',
    description: "Offer Holder Only Event, where you can learn more about warwick and what to prepared before going there!",
    img: event,
    date: '03/07/2022 14:00'
}